
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","fill-rule":"evenodd","d":"M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm0 16H5V5h14v14zm-9-3.65a.477.477 0 00.7 0l5.62-5.62a.5.5 0 000-.71l-.53-.53a.501.501 0 00-.7 0l-4.74 4.74-1.5-1.49a.477.477 0 00-.7 0l-.53.53a.5.5 0 000 .71L10 15.35z","opacity":".75"}})])
          )
        }
      }
    